import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const ConnectionPageContainer = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    height: 100%;
`;

type ConnectionPageContentProps = {
    hasBackgroundColor?: boolean;
};

export const ConnectionPageLeftPart = styled.div<ConnectionPageContentProps>`
    display: flex;
    flex-basis: 100%;
    justify-content: center;

    @media (max-width: 768px) {
        padding-top: 48px;
        align-items: start;
    }

    ${({ hasBackgroundColor, theme }) =>
        !hasBackgroundColor &&
        css`
            background-color: ${theme.colors.theme.initial};
        `}
`;

export const ConnectionPageLeftPartContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
    max-width: 430px;
    flex-grow: 1;
    padding: 0 24px;
    justify-content: center;
`;

export const SwitchThemeWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    margin: 30px;
`;

export const ConnectionPageRightPart = styled.div`
    display: flex;
    flex-basis: 100%;
    overflow: hidden;
    position: relative;
`;
